// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { DataTableCell, DataTableRow, Link } from "@insite/mobius/index";
import { HotSheetContext } from "@stanion/App/Pages/HotSheetPage";
import ProductPrice from "@stanion/Overrides/Components/ProductPrice";
import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.id, ownProps.product.id),
});

const mapDispatchToProps = {};

interface OwnProps {
    id: string;
    product: ProductModel;
    title: string;
    productTitle?: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface HotSheetTableProductsStyles {}

export const hotSheetTableProductsStyles: HotSheetTableProductsStyles = {};

const HotSheetTableProducts = ({ product, productInfo, id, title, productTitle }: Props) => {
    const hotSheetContext = useContext(HotSheetContext);

    useEffect(() => {
        if (productInfo && productInfo.pricing) {
            hotSheetContext.setViews(prevViews => ({
                ...prevViews,
                [id]: {
                    title,
                    products: [
                        ...(prevViews[id]?.products || []),
                        {
                            erpNumber: productTitle || product.productNumber,
                            price: `${productInfo.pricing?.unitNetPriceDisplay}/${productInfo?.pricing?.unitOfMeasure}`,
                        },
                    ],
                },
            }));
        }
    }, [productInfo?.pricing]);

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
    };

    return (
        <DataTableRow>
            <DataTableCell>
                <Link
                    href={productInfo.productDetailPath}
                    alt={`See product details for ${product.productNumber}`}
                    data-test-selector="productNumberLink"
                >
                    {productTitle || product.productNumber}
                </Link>
            </DataTableCell>
            <DataTableCell>
                <ProductPrice product={productContext} showLabel={false} showSavings={false} showPack={false} />
            </DataTableCell>
        </DataTableRow>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(HotSheetTableProducts);
